import { useEffect, useState } from "react";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import axiosInstance from '../networking/axiosconfig';
import toast, { Toaster } from 'react-hot-toast';
import { IoIosAdd } from "react-icons/io";
export default function Designationpopup({ onClose, selectedId }) {

    const [error, setError] = useState({});
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(true)

    const designationUrl = `/api/designation`;

    const [DesignationFormData, setDesignationFormData] = useState({
        designation_name: '',
    });
    const handleChange = (e) => {
        setDesignationFormData({
            ...DesignationFormData,
            [e.target.name]: e.target.value
        });
    }



    // valiadtion for Holidayform
    const validateDesignationForm = (formData) => {
        let errors = {};
        if (!formData.designation_name.trim()) errors.designation_name = 'Designation name is required';

        return errors;
    };

    //add department api
    const addDesignationData = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.post(`/api/designation`,
                DesignationFormData
            );
            if (response.data.status) {
                toast.success("Designation Added Successfully");
            }
            console.log('Response:', response);
            setTimeout(() => window.location.href = '/designation', 2000);
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    // Fetch Department Data for Editing
    useEffect(() => {
        const fetchDepartmentData = async (id) => {
            if (!id) return;

            try {
                const response = await axiosInstance.get(`${designationUrl}/${id}`);
                if (response.data && response.data.data) {
                    setDesignationFormData({
                        designation_name: response.data.data.designation_name || '',
                    });
                }
            } catch (error) {
                console.error("Error fetching department data:", error);
            }
        };

        if (selectedId) {
            fetchDepartmentData(selectedId);
        } else {
            setDesignationFormData({ designation_name: '', designation_id: '' }); // Reset for Add
        }
    }, [selectedId]);

    //Update Designation Data
    const handleUpdate = async () => {
        if (!selectedId) {
            console.error("Error: Designation id is missing!");
            return;
        }

        setLoading(true);

        const updatedData = { designation_name: DesignationFormData.designation_name };

        try {
            await axiosInstance.patch(`/api/designation/${selectedId}`, updatedData);
            toast.success("Designationt Updated Successfully");
            setTimeout(() => {
                window.location.href = '/designation';
            }, 2000);
        } catch (error) {
            console.error("Error updating designation:", error);

        } finally {
            setLoading(false);
        }
    };

    //form submit for add and edit
    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validateDesignationForm(DesignationFormData);
        setError(validationErrors);
        console.log("Validation error", validationErrors)

        if (Object.keys(validationErrors).length === 0) {
            selectedId ? handleUpdate() : addDesignationData();
        }

    };

    //cancel button redirect to department
    const handleCancelButton = () => {
        setOpen(false);
    }


    return (
        <Dialog open={open} onClose={setOpen} className="relative z-10 " >
            {/* toast for success and error message  */}
            <Toaster
                position="top-right"
                reverseOrder={false}
            />

            <DialogBackdrop transition
                className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <form onSubmit={handleSubmit}>
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-8 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            <div className='flex-col space-y-4'>
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-800 text-white p-4 flex justify-between items-center rounded-xl">
                                    <DialogTitle as="h3" className="mx-auto flex text-xl font-inter font-semibold  items-center justify-center">
                                        {!selectedId && <IoIosAdd className="w-5 h-5" />}
                                        {selectedId ? "Edit Designation" : "Add Designation"}

                                    </DialogTitle>
                                </div>
                                <div className="mt-3 text-center sm:mt-5 ">

                                    {/* Designation Name */}
                                    <div className='space-y-2'>
                                        <label htmlFor="designation_name" className="flex text-base font-medium font-inter text-gray-900">
                                            Designation<span className="text-red-500">*</span>
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                name="designation_name"
                                                value={DesignationFormData.designation_name}
                                                id="designation_name"
                                                onChange={handleChange}
                                                type="text"
                                                autoComplete="off"
                                                className={`block w-full rounded-md font-inter bg-white px-3 py-2.5 text-base text-gray-900 
outline outline-1 -outline-offset-1 placeholder:text-gray-400 sm:text-sm 
${error.department_name ? 'border-red-500 outline-red-500' : 'outline-gray-300 focus:outline-indigo-600'}`}
                                                placeholder="Enter Designation"
                                            />
                                            {error.designation_name && (
                                                <p className="text-red-600 font-inter text-sm">{error.designation_name}</p>
                                            )}
                                        </div>
                                    </div>




                                </div>
                            </div>
                            <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3 flex flex-row">
                                <button
                                    type="button"
                                    // onClick={handleCancelButton}
                                    onClick={() => setOpen(false)}
                                    className="text-sm font-inter font-semibold text-black bg-transparent border border-blue-500 px-4 py-2 rounded-md "
                                >
                                    Cancel
                                </button>


                                <button
                                    type="submit"

                                    disabled={loading}
                                    className={`inline-flex justify-center items-center font-inter rounded-md bg-blue-600 px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 
                ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                                >
                                    {loading ? (
                                        <div className="flex items-center">
                                            <svg className="animate-spin h-5 w-5 text-white mr-2" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                                            </svg>
                                            Saving...
                                        </div>
                                    ) : (
                                        "Save"
                                    )}
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </form>
        </Dialog>
    )
}